import React from "react";

import { FadeIn } from "../Utilities/FadeIn";

import iconMail from "../../images/icon_chat.svg";
import iconInsta from "../../images/icon_insta.svg";
import iconPlus from "../../images/icon_contact.svg";

// plugins
import { useBreakpoint } from "gatsby-plugin-breakpoints";
import { Link } from "gatsby";

const Footer = ({ pathname }: { pathname: string }) => {
  const { sm: isMobile } = useBreakpoint();

  return (
    <footer>
      <nav className="footer-navbar">
        {pathname !== "/" ? (
          <button onClick={() => history.back()}>{"<"}</button>
        ) : null}

        <ul
          style={{
            width: "100%",
            justifyContent: isMobile ? "center" : "flex-end",
          }}
        >
          <li>
            <a href={`mailto:hi@julielobo.com`}>
              <img src={iconMail} alt="A speak bubble icon" />
            </a>
          </li>
          <li>
            <a href={`https://instagram.com/avertigem/`}>
              <img src={iconInsta} alt="Instagram Logo" />
            </a>
          </li>
          <li>
            <Link to="/about">
              <img src={iconPlus} alt="More" />
            </Link>
          </li>
        </ul>
      </nav>
    </footer>
  );
};

export default Footer;
